// extracted by mini-css-extract-plugin
module.exports = {"g2k":"GoodToKnow_g2k__K6516"};